<template>
  <div>
    <div class="contentsList couponList">
      <ul v-for="couponCategory in couponList">
        <li class="shopCategoryName">
          <p>{{ couponCategory[0].large_category_name }}</p>
        </li>
        <li v-for="coupon in couponCategory">
          <div class="contentsWrap">
            <a :href="coupon.url" class="eyecatch">
              <img v-if="coupon.full_image_path" :data-src="coupon.full_image_path" :alt="coupon.name" class="lazyload">
              <img v-else src="/img/aloco_img_1.svg" :alt="coupon.name">
            </a>
            <div class="detail">
              <p class="info">{{ coupon.shop_name }}</p>
              <div class="name">
                <a :href="coupon.url">{{ coupon.title }}</a>
              </div>
              <div class="categories">
                <div class="category">{{ coupon.genre_name }}</div>
                <div class="icon heart">{{ coupon.liked }}</div>
              </div>
            </div>
            <div @click.stop="changeLike($event, coupon, 5)" class="favoriteIcon"></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="contentsList shopList">
      <ul v-for="shopCategory in shopList">
        <li class="shopCategoryName">
          <p>{{ shopCategory[0].large_category_name }}</p>
        </li>
        <li v-for="shop in shopCategory">
          <div class="contentsWrap">
            <a :href="shop.url" class="eyecatch">
              <img v-if="shop.full_image_path" :data-src="shop.full_image_path" :alt="shop.name" class="lazyload">
              <img v-else src="/img/aloco_img_1.svg" :alt="shop.name">
            </a>
            <div class="detail">
              <div class="location">
                <ol>
                  <li>{{ shop.area_info.island_name }}</li>
                  <li>{{ shop.area_info.area_name }}</li>
                </ol>
              </div>
              <div class="name">
                <a :href="shop.url">{{ shop.shop_name }}</a>
              </div>
              <div class="categories">
                <div class="category">{{ shop.category.name_public }}</div>
                <div class="icon heart">{{ shop.liked }}</div>
              </div>
            </div>
            <div @click.stop="changeLike($event, shop, 1)" class="favoriteIcon"></div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="contentsList articleList">
      <li v-for="article in articleList">
        <div class="contentsWrap">
          <a :href="article.url" class="eyecatch">
            <img v-if="article.eyecatch_img_path" :data-src="article.eyecatch_img_path" :alt="article.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="article.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="article.url">{{ article.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ article.category.name_public }}</div>
              <div class="icon heart">{{ article.liked }}</div>
            </div>
          </div>
          <div @click.stop="changeLike($event, article, 2)" class="favoriteIcon"></div>
        </div>
      </li>
    </ul>
    <ul class="contentsList movieList">
      <li v-for="movie in movieList">
        <div class="contentsWrap">
          <a :href="movie.url" class="eyecatch">
            <img v-if="movie.eyecatch_img_path" :data-src="movie.eyecatch_img_path" :alt="movie.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="movie.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="movie.url">{{ movie.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ movie.category.name_public }}</div>
              <div class="icon heart">{{ movie.liked }}</div>
            </div>
          </div>
          <div @click.stop="changeLike($event, movie, 3)" class="favoriteIcon"></div>
        </div>
      </li>
    </ul>
    <ul class="contentsList giftList">
      <li v-for="gift in giftList">
        <div class="contentsWrap">
          <a :href="gift.url" class="eyecatch">
            <img v-if="gift.eyecatch_img_path" :data-src="gift.eyecatch_img_path" :alt="gift.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="gift.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="gift.url">{{ gift.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ gift.category.name_public }}</div>
              <div class="icon heart">{{ gift.liked }}</div>
            </div>
          </div>
          <div @click.stop="changeLike($event, gift, 4)" class="favoriteIcon"></div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
      return {
        couponList: [],
        shopList: [],
        articleList: [],
        movieList: [],
        giftList: [],
        params: {
          coupon: [],
          shop: [],
          article: [],
          movie: [],
          gift: []
        }
      }
  },
  mounted() {
    this.getLocalStorage()
  },
  methods: {
    getLocalStorage() {
      const localStorageKeys = ['couponLike', 'shopLike', 'articleLike', 'movieLike', 'giftLike'];
      localStorageKeys.forEach(key => {
        const value = localStorage.getItem(key);
        if (value) {
          this.params[key.replace('Like', '')] = JSON.parse(value);
        }
      });
      this.getLikeInfo();
    },
    async getLikeInfo() {
      // お気に入り情報取得API
      await axios.post('/api/users/like/get', this.params).then(res => {
        if (res.data.success) {
          this.couponList = this.sortList(res.data.coupon, 'coupon');
          this.shopList = this.sortList(res.data.shop, 'shop');
          this.articleList = this.sortList(res.data.article, 'article');
          this.movieList = this.sortList(res.data.movie, 'movie');
          this.giftList = this.sortList(res.data.gift, 'gift');
        } else {
          this.errors = res.data.errors
        }
      }).catch(e => {
        console.log('Error', e)
      });
    },
    sortList(list, key) {
      if (Array.isArray(list)) {
        return list.sort((a, b) => this.params[key].indexOf(a.id) - this.params[key].indexOf(b.id));
      } else {
        return list;
      }
    },
    changeLike(e, content, contentType) {
      this.$axios.post('/api/users/like/delete', {
        content_id: content.id,
        content_type: contentType
      })
        .then((res) => {
          if (res.status === 200) {
            content.likeFlag = false
            content.totalLike -= 1
            e.target.closest('li').remove();
            this.updateLocalStorage(content.id, contentType);
          }
        })
        .catch((e) => {
          console.log('Error', e)
        })
    },
    updateLocalStorage(id, type) {
      let key;
      switch (type) {
        case 1:
          key = 'shop'
          break;
        case 2:
          key = 'article'
          break;
        case 3:
          key = 'movie'
          break;
        case 4:
          key = 'gift'
          break;
        case 5:
          key = 'coupon'
          break;
      }
      let keyName = key + 'Like';
      const storage = JSON.parse(localStorage.getItem(keyName)) || [];
      const updatedData = storage.filter(item => item !== id);
      localStorage.setItem(keyName, JSON.stringify(updatedData));
    }
  }
}
</script>

<style lang="scss">
.favorites {
  .wrapper {
    @media screen and (max-width: 768px) {
      width: 100%;
      display: block;
      margin: auto;
      padding: 0 1.5rem;
    }
  }
  .contentsList {
    li {
      margin-top: 20px;
    }

    .location {
      li {
        margin-top: 0;
      }
    }
  }
}
</style>
